// extracted by mini-css-extract-plugin
export default {"root":"EditIntegration_root__pDje9","credentials":"EditIntegration_credentials__Wkwi2","title":"EditIntegration_title__oUrzG","save":"EditIntegration_save__AguIJ"};